import ReviewCard from '../../../../../ReviewCard';

import type { Review } from '@shared/types/frontend/ubff/hotel-reviews';

import STYLES from './ReviewCardList.module.scss';

type Props = {
  elements: Review[];
};

const ReviewCardList = ({ elements: reviews }: Props) => (
  <div className={STYLES.ReviewCardList}>
    {reviews.map((review, index) => (
      <ReviewCard
        key={`${review.partnerReviewId}-${review.partner}`}
        review={review}
        reviewIndex={index}
      />
    ))}
  </div>
);

export default ReviewCardList;
